import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import classNames from 'classnames'
import { observer } from 'mobx-react'

import PropTypes from 'prop-types'
import { PropTypes as MobXPropTypes } from 'mobx-react'

import { Range } from 'rc-slider'
import 'rc-slider/assets/index.css'

@observer
export default class SchoolsSection extends Component {
  static propTypes = {
    grade: MobXPropTypes.observableArray,
    groupSize: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    schools: PropTypes.array,
    section: PropTypes.string.isRequired
  };

  @autobind
  handleGradeChange(value) {
    if (this.props.onChange) {
      this.props.onChange({
        target: {
          name: 'grade',
          value
        }
      })
    }
  }

  render() {
    const {
      section, schools, grade, onRemove, groupSize
    } = this.props
    return (
      <section
        className={classNames('filter-definition', 'bg-tab-schools', {
          show: section === 'schools'
        })}
      >
        <h3 className="active">
          Schulart &amp; Jahrgangstufe
          <button onClick={onRemove} className="btn btn-link reset-filter">
            <i className="glyphicon glyphicon-trash" />
          </button>
        </h3>
        <div className="scrollable">
          <div className="form-group school-filter">
            {window.APP_CONFIG.list_school.map((school) => {
              return (
                <div key={`school-${school.id}`}>
                  <label
                    htmlFor={`filter-school-${school.id}`}
                    className="small"
                  >
                    <input
                      id={`filter-school-${school.id}`}
                      type="checkbox"
                      name="school"
                      defaultValue={school.id}
                      checked={schools.indexOf(school.id) !== -1}
                    />
                    <span>{school.title}</span>
                  </label>
                </div>
              )
            })}
          </div>

          <div className="form-group grade-filter col-xs-12">
            <div className="container-fluid">
              <div className="row no-margin grade-filter-container">
                <svg className="grade-icon-small">
                  <use xlinkHref="#icon-grade-grey" />
                </svg>

                <svg className="grade-icon-large">
                  <use xlinkHref="#icon-grade-grey" />
                </svg>

                <div className="grade-container">
                  <Range
                    allowCross={false}
                    min={1}
                    max={13}
                    value={grade}
                    defaultValue={[grade[0], grade[1]]}
                    onChange={this.handleGradeChange}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 text-muted text-small">
                  <label htmlFor="filter-grade-lower">Jahrgangsstufe</label>
                  <input
                    type="number"
                    id="filter-grade-lower"
                    name="grade[0]"
                    value={grade[0]}
                    className="grade-input number form-control"
                  />
                  <label htmlFor="filter-grade-upper" className="inline">&nbsp;bis&nbsp;</label>
                  <input
                    type="number"
                    id="filter-grade-upper"
                    name="grade[1]"
                    value={grade[1]}
                    className="grade-input number form-control"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 text-muted text-small">
                  <label htmlFor="filter-group-size">Teilnehmerzahl</label>
                  <input
                    type="number"
                    id="filter-group-size"
                    name="groupSize"
                    value={groupSize}
                    className="group-size-input number form-control"
                  />

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/frontend/map/components/SchoolsSection.js